
import { SYMBOL } from '@/collocate';
import ReturnCom from '@/components/ReturnCom';
import bg1 from '@/image/bg1.svg';
import bg2 from '@/image/bg2.png';
import { useTranslation } from 'react-i18next';
import useGetUserInfo from '@/web3Hook/useGetUserInfo';
import BalanceCom from '@/components/BalanceCom';
const PowerPool = () => {
    const { t } = useTranslation()
    const { userInfo, userInfoLod } = useGetUserInfo();

    return (
        <div className='relative'>
            <div className='px-4 mt-3.5 md:max-w-[750px] md:mx-auto md:mt-6'>
                < ReturnCom title={t('powerPool.miningPool')} />
            </div>
            <div className="bg-1 w-full absolute left-0 top-0 -z-10">
                <img src={bg1} className='w-full h-full' alt="" />
            </div>
            <div className='fixed left-1/2 top-[40%] -translate-x-1/2 min-w-73.75 md:min-w-[400px]'>
                <div className='w-full h-full relative'>
                    <img className='w-full h-full' src={bg2} alt="" />
                    <div className='text-white text-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full px-4'>
                        <div className='text-sm md:text-base pb-4 md:pb-6'>{t('powerPool.currentTotalHashrate')}</div>
                        <div className='text-22px md:text-3xl font-medium'><BalanceCom balance={userInfo.poolBalance} loading={userInfoLod} text={' ' + SYMBOL} /></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PowerPool